let logoutFn: (() => void) | null = null;

export const setLogout = (fn: () => void) => {
  logoutFn = fn;
};

export const logout = () => {
  if (!logoutFn) {
    throw new Error("logout not initialized");
  }
  logoutFn();
};


let token: string | null = null;

export const setToken = (value: string | null) => {
  token = value;
};

export const getToken = () => token;